import type { OptionsDocument, PresentationOption } from 'paintscout'
import shuffle from 'lodash/shuffle'

export function getDefaultPresentationImages(args: { options: OptionsDocument; presentation: PresentationOption }) {
  const { presentation } = args

  if (presentation.advanced.defaultImages && presentation.advanced.defaultImages.length > 0) {
    return shuffle(presentation.advanced.defaultImages)
  }

  return []
}
